import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Compass } from "lucide-react";

export function NoItineraries() {
    return (
        <div className="text-center py-16 border-2 border-dashed rounded-lg">
            <h2 className="text-xl font-semibold">No Expeditions Saved Yet</h2>
            <p className="text-muted-foreground mt-2 mb-6">Explore our pre-built routes and save your favorites to get started.</p>
            <Button asChild>
                <Link to="/itinerary/discover">
                    <Compass className="mr-2 h-4 w-4" />
                    Discover Routes
                </Link>
            </Button>
        </div>
    )
}
